/* eslint-disable */
import axios from "axios";
import qs from "qs";
import { getDomain, getToken, setDomain } from "./base-api";
export const request = (method, url, body, queryParameters, form, config) => {
  method = method.toLowerCase();
  let keys = Object.keys(queryParameters);
  let queryUrl = url;
  if (keys.length > 0) {
    queryUrl = url + "?" + qs.stringify(queryParameters);
  }
  // let queryUrl = url+(keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
  config = config ? config : getToken();
  if (body) {
    return axios[method](queryUrl, body, config);
  } else if (method === "get") {
    return axios[method](queryUrl, config);
  } else {
    return axios[method](queryUrl, qs.stringify(form), config);
  }
};
/*==========================================================
 *                    Eruhsat Authentication ASP.NET Core Auth API
 ==========================================================*/
/**
 * Detailed account informations
 * request: getApiAuthAccount
 * url: getApiAuthAccountURL
 * method: getApiAuthAccount_TYPE
 * raw_url: getApiAuthAccount_RAW_URL
 */
export const getApiAuthAccount = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/Account";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("get", domain + path, body, queryParameters, form, config);
};
export const getApiAuthAccount_RAW_URL = function () {
  return "/api/auth/Account";
};
export const getApiAuthAccount_TYPE = function () {
  return "get";
};
export const getApiAuthAccountURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/Account";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: putApiAuthAccount
 * url: putApiAuthAccountURL
 * method: putApiAuthAccount_TYPE
 * raw_url: putApiAuthAccount_RAW_URL
 * @param email -
 * @param phone -
 * @param pubemail -
 * @param pubphone -
 * @param picture -
 * @param twoFactorEnabled -
 * @param corporateName -
 * @param corporateTaxnumber -
 * @param corporateTaxadministrationId -
 * @param corporateAddress -
 * @param corporateCity -
 * @param corporateFax -
 * @param corporateWeb -
 * @param corporateCorporatetypeId -
 * @param singularFirstName -
 * @param singularLastName -
 * @param singularTc -
 * @param singularSingulartypeId -
 * @param singularBirthyear -
 */
export const putApiAuthAccount = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/Account";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters["email"] !== undefined) {
    form["Email"] = parameters["email"];
  }
  if (parameters["phone"] !== undefined) {
    form["Phone"] = parameters["phone"];
  }
  if (parameters["pubemail"] !== undefined) {
    form["Pubemail"] = parameters["pubemail"];
  }
  if (parameters["pubphone"] !== undefined) {
    form["Pubphone"] = parameters["pubphone"];
  }
  if (parameters["picture"] !== undefined) {
    form["Picture"] = parameters["picture"];
  }
  if (parameters["twoFactorEnabled"] !== undefined) {
    form["TwoFactorEnabled"] = parameters["twoFactorEnabled"];
  }
  if (parameters["corporateName"] !== undefined) {
    form["Corporate.Name"] = parameters["corporateName"];
  }
  if (parameters["corporateTaxnumber"] !== undefined) {
    form["Corporate.Taxnumber"] = parameters["corporateTaxnumber"];
  }
  if (parameters["corporateTaxadministrationId"] !== undefined) {
    form["Corporate.TaxadministrationId"] =
      parameters["corporateTaxadministrationId"];
  }
  if (parameters["corporateAddress"] !== undefined) {
    form["Corporate.Address"] = parameters["corporateAddress"];
  }
  if (parameters["corporateCity"] !== undefined) {
    form["Corporate.City"] = parameters["corporateCity"];
  }
  if (parameters["corporateFax"] !== undefined) {
    form["Corporate.Fax"] = parameters["corporateFax"];
  }
  if (parameters["corporateWeb"] !== undefined) {
    form["Corporate.Web"] = parameters["corporateWeb"];
  }
  if (parameters["corporateCorporatetypeId"] !== undefined) {
    form["Corporate.CorporatetypeId"] = parameters["corporateCorporatetypeId"];
  }
  if (parameters["singularFirstName"] !== undefined) {
    form["Singular.FirstName"] = parameters["singularFirstName"];
  }
  if (parameters["singularLastName"] !== undefined) {
    form["Singular.LastName"] = parameters["singularLastName"];
  }
  if (parameters["singularTc"] !== undefined) {
    form["Singular.Tc"] = parameters["singularTc"];
  }
  if (parameters["singularSingulartypeId"] !== undefined) {
    form["Singular.SingulartypeId"] = parameters["singularSingulartypeId"];
  }
  if (parameters["singularBirthyear"] !== undefined) {
    form["Singular.Birthyear"] = parameters["singularBirthyear"];
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("put", domain + path, body, queryParameters, form, config);
};
export const putApiAuthAccount_RAW_URL = function () {
  return "/api/auth/Account";
};
export const putApiAuthAccount_TYPE = function () {
  return "put";
};
export const putApiAuthAccountURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/Account";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: getApiAuthAccountLdap
 * url: getApiAuthAccountLdapURL
 * method: getApiAuthAccountLdap_TYPE
 * raw_url: getApiAuthAccountLdap_RAW_URL
 */
export const getApiAuthAccountLdap = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/Account/LDAP";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("get", domain + path, body, queryParameters, form, config);
};
export const getApiAuthAccountLdap_RAW_URL = function () {
  return "/api/auth/Account/LDAP";
};
export const getApiAuthAccountLdap_TYPE = function () {
  return "get";
};
export const getApiAuthAccountLdapURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/Account/LDAP";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: putApiAuthAccountSmsNotification
 * url: putApiAuthAccountSmsNotificationURL
 * method: putApiAuthAccountSmsNotification_TYPE
 * raw_url: putApiAuthAccountSmsNotification_RAW_URL
 * @param value -
 */
export const putApiAuthAccountSmsNotification = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/Account/SmsNotification";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters["value"] !== undefined) {
    form["value"] = parameters["value"];
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("put", domain + path, body, queryParameters, form, config);
};
export const putApiAuthAccountSmsNotification_RAW_URL = function () {
  return "/api/auth/Account/SmsNotification";
};
export const putApiAuthAccountSmsNotification_TYPE = function () {
  return "put";
};
export const putApiAuthAccountSmsNotificationURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/Account/SmsNotification";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: putApiAuthAccountWebNotification
 * url: putApiAuthAccountWebNotificationURL
 * method: putApiAuthAccountWebNotification_TYPE
 * raw_url: putApiAuthAccountWebNotification_RAW_URL
 * @param value -
 */
export const putApiAuthAccountWebNotification = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/Account/WebNotification";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters["value"] !== undefined) {
    form["value"] = parameters["value"];
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("put", domain + path, body, queryParameters, form, config);
};
export const putApiAuthAccountWebNotification_RAW_URL = function () {
  return "/api/auth/Account/WebNotification";
};
export const putApiAuthAccountWebNotification_TYPE = function () {
  return "put";
};
export const putApiAuthAccountWebNotificationURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/Account/WebNotification";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: putApiAuthAccountMailNotification
 * url: putApiAuthAccountMailNotificationURL
 * method: putApiAuthAccountMailNotification_TYPE
 * raw_url: putApiAuthAccountMailNotification_RAW_URL
 * @param value -
 */
export const putApiAuthAccountMailNotification = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/Account/MailNotification";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters["value"] !== undefined) {
    form["value"] = parameters["value"];
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("put", domain + path, body, queryParameters, form, config);
};
export const putApiAuthAccountMailNotification_RAW_URL = function () {
  return "/api/auth/Account/MailNotification";
};
export const putApiAuthAccountMailNotification_TYPE = function () {
  return "put";
};
export const putApiAuthAccountMailNotificationURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/Account/MailNotification";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: postApiAuthAccountPasswordchange
 * url: postApiAuthAccountPasswordchangeURL
 * method: postApiAuthAccountPasswordchange_TYPE
 * raw_url: postApiAuthAccountPasswordchange_RAW_URL
 * @param oldPassword -
 * @param newPassword -
 */
export const postApiAuthAccountPasswordchange = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/Account/passwordchange";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters["oldPassword"] !== undefined) {
    form["OldPassword"] = parameters["oldPassword"];
  }
  if (parameters["newPassword"] !== undefined) {
    form["NewPassword"] = parameters["newPassword"];
  }
  if (parameters["newPassword"] === undefined) {
    return Promise.reject(
      new Error("Missing required  parameter: newPassword")
    );
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("post", domain + path, body, queryParameters, form, config);
};
export const postApiAuthAccountPasswordchange_RAW_URL = function () {
  return "/api/auth/Account/passwordchange";
};
export const postApiAuthAccountPasswordchange_TYPE = function () {
  return "post";
};
export const postApiAuthAccountPasswordchangeURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/Account/passwordchange";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: postApiAuthAccountAdminPasswordchange
 * url: postApiAuthAccountAdminPasswordchangeURL
 * method: postApiAuthAccountAdminPasswordchange_TYPE
 * raw_url: postApiAuthAccountAdminPasswordchange_RAW_URL
 * @param userId -
 * @param newPassword -
 */
export const postApiAuthAccountAdminPasswordchange = function (
  parameters = {}
) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/Account/admin/passwordchange";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters["userId"] !== undefined) {
    form["UserId"] = parameters["userId"];
  }
  if (parameters["userId"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: userId"));
  }
  if (parameters["newPassword"] !== undefined) {
    form["NewPassword"] = parameters["newPassword"];
  }
  if (parameters["newPassword"] === undefined) {
    return Promise.reject(
      new Error("Missing required  parameter: newPassword")
    );
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("post", domain + path, body, queryParameters, form, config);
};
export const postApiAuthAccountAdminPasswordchange_RAW_URL = function () {
  return "/api/auth/Account/admin/passwordchange";
};
export const postApiAuthAccountAdminPasswordchange_TYPE = function () {
  return "post";
};
export const postApiAuthAccountAdminPasswordchangeURL = function (
  parameters = {}
) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/Account/admin/passwordchange";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: postApiAuthJwtLogin
 * url: postApiAuthJwtLoginURL
 * method: postApiAuthJwtLogin_TYPE
 * raw_url: postApiAuthJwtLogin_RAW_URL
 * @param recaptcha -
 * @param password -
 * @param email -
 * @param tc -
 * @param taxnumber -
 * @param codeOtp -
 */
export const postApiAuthJwtLogin = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/Jwt/login";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters["recaptcha"] !== undefined) {
    queryParameters["recaptcha"] = parameters["recaptcha"];
  }
  if (parameters["password"] !== undefined) {
    form["Password"] = parameters["password"];
  }
  if (parameters["email"] !== undefined) {
    form["Email"] = parameters["email"];
  }
  if (parameters["tc"] !== undefined) {
    form["Tc"] = parameters["tc"];
  }
  if (parameters["taxnumber"] !== undefined) {
    form["Taxnumber"] = parameters["taxnumber"];
  }
  if (parameters["codeOtp"] !== undefined) {
    form["CodeOTP"] = parameters["codeOtp"];
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("post", domain + path, body, queryParameters, form, config);
};
export const postApiAuthJwtLogin_RAW_URL = function () {
  return "/api/auth/Jwt/login";
};
export const postApiAuthJwtLogin_TYPE = function () {
  return "post";
};
export const postApiAuthJwtLoginURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/Jwt/login";
  if (parameters["recaptcha"] !== undefined) {
    queryParameters["recaptcha"] = parameters["recaptcha"];
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: postApiAuthJwtRefreshToken
 * url: postApiAuthJwtRefreshTokenURL
 * method: postApiAuthJwtRefreshToken_TYPE
 * raw_url: postApiAuthJwtRefreshToken_RAW_URL
 * @param refresh_token -
 */
export const postApiAuthJwtRefreshToken = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/Jwt/refresh-token";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters["refresh_token"] !== undefined) {
    form["refresh_token"] = parameters["refresh_token"];
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("post", domain + path, body, queryParameters, form, config);
};
/**
 * Oturumu sunucuda kapatır (sahiplik kanıtı refresh token'dır; idempotent).
 * request: postApiAuthJwtLogout
 * @param refresh_token -
 */
export const postApiAuthJwtLogout = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/Jwt/logout";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters["refresh_token"] !== undefined) {
    form["refresh_token"] = parameters["refresh_token"];
  }
  return request("post", domain + path, body, queryParameters, form, config);
};
export const postApiAuthJwtRefreshToken_RAW_URL = function () {
  return "/api/auth/Jwt/refresh-token";
};
export const postApiAuthJwtRefreshToken_TYPE = function () {
  return "post";
};
export const postApiAuthJwtRefreshTokenURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/Jwt/refresh-token";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: postApiAuthJwtRevokeToken
 * url: postApiAuthJwtRevokeTokenURL
 * method: postApiAuthJwtRevokeToken_TYPE
 * raw_url: postApiAuthJwtRevokeToken_RAW_URL
 * @param id -
 * @param token -
 */
export const postApiAuthJwtRevokeToken = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/Jwt/revoke-token";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters["id"] !== undefined) {
    form["id"] = parameters["id"];
  }
  if (parameters["id"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: id"));
  }
  if (parameters["token"] !== undefined) {
    form["token"] = parameters["token"];
  }
  if (parameters["token"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: token"));
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("post", domain + path, body, queryParameters, form, config);
};
export const postApiAuthJwtRevokeToken_RAW_URL = function () {
  return "/api/auth/Jwt/revoke-token";
};
export const postApiAuthJwtRevokeToken_TYPE = function () {
  return "post";
};
export const postApiAuthJwtRevokeTokenURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/Jwt/revoke-token";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: getApiAuthSignin
 * url: getApiAuthSigninURL
 * method: getApiAuthSignin_TYPE
 * raw_url: getApiAuthSignin_RAW_URL
 */
export const getApiAuthSignin = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/signin";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("get", domain + path, body, queryParameters, form, config);
};
export const getApiAuthSignin_RAW_URL = function () {
  return "/api/auth/signin";
};
export const getApiAuthSignin_TYPE = function () {
  return "get";
};
export const getApiAuthSigninURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/signin";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: postApiAuthSignin
 * url: postApiAuthSigninURL
 * method: postApiAuthSignin_TYPE
 * raw_url: postApiAuthSignin_RAW_URL
 * @param provider -
 */
export const postApiAuthSignin = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/signin";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters["provider"] !== undefined) {
    form["provider"] = parameters["provider"];
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("post", domain + path, body, queryParameters, form, config);
};
export const postApiAuthSignin_RAW_URL = function () {
  return "/api/auth/signin";
};
export const postApiAuthSignin_TYPE = function () {
  return "post";
};
export const postApiAuthSigninURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/signin";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: getApiAuthEdevletAvailable
 * url: getApiAuthEdevletAvailableURL
 * method: getApiAuthEdevletAvailable_TYPE
 * raw_url: getApiAuthEdevletAvailable_RAW_URL
 */
export const getApiAuthEdevletAvailable = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/edevlet/available";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("get", domain + path, body, queryParameters, form, config);
};
export const getApiAuthEdevletAvailable_RAW_URL = function () {
  return "/api/auth/edevlet/available";
};
export const getApiAuthEdevletAvailable_TYPE = function () {
  return "get";
};
export const getApiAuthEdevletAvailableURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/edevlet/available";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: getApiAuthEdevletSession
 * url: getApiAuthEdevletSessionURL
 * method: getApiAuthEdevletSession_TYPE
 * raw_url: getApiAuthEdevletSession_RAW_URL
 */
export const getApiAuthEdevletSession = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/edevlet/session";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("get", domain + path, body, queryParameters, form, config);
};
export const getApiAuthEdevletSession_RAW_URL = function () {
  return "/api/auth/edevlet/session";
};
export const getApiAuthEdevletSession_TYPE = function () {
  return "get";
};
export const getApiAuthEdevletSessionURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/edevlet/session";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: postApiAuthEdevletVerify
 * url: postApiAuthEdevletVerifyURL
 * method: postApiAuthEdevletVerify_TYPE
 * raw_url: postApiAuthEdevletVerify_RAW_URL
 * @param code -
 * @param state -
 */
export const postApiAuthEdevletVerify = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/edevlet/verify";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters["code"] !== undefined) {
    queryParameters["code"] = parameters["code"];
  }
  if (parameters["code"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: code"));
  }
  if (parameters["state"] !== undefined) {
    queryParameters["state"] = parameters["state"];
  }
  if (parameters["state"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: state"));
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("post", domain + path, body, queryParameters, form, config);
};
export const postApiAuthEdevletVerify_RAW_URL = function () {
  return "/api/auth/edevlet/verify";
};
export const postApiAuthEdevletVerify_TYPE = function () {
  return "post";
};
export const postApiAuthEdevletVerifyURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/edevlet/verify";
  if (parameters["code"] !== undefined) {
    queryParameters["code"] = parameters["code"];
  }
  if (parameters["state"] !== undefined) {
    queryParameters["state"] = parameters["state"];
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: postApiAuthSigninGoogle
 * url: postApiAuthSigninGoogleURL
 * method: postApiAuthSigninGoogle_TYPE
 * raw_url: postApiAuthSigninGoogle_RAW_URL
 */
export const postApiAuthSigninGoogle = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/signin-google";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("post", domain + path, body, queryParameters, form, config);
};
export const postApiAuthSigninGoogle_RAW_URL = function () {
  return "/api/auth/signin-google";
};
export const postApiAuthSigninGoogle_TYPE = function () {
  return "post";
};
export const postApiAuthSigninGoogleURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/signin-google";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: getApiAuthSignout
 * url: getApiAuthSignoutURL
 * method: getApiAuthSignout_TYPE
 * raw_url: getApiAuthSignout_RAW_URL
 */
export const getApiAuthSignout = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/signout";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("get", domain + path, body, queryParameters, form, config);
};
export const getApiAuthSignout_RAW_URL = function () {
  return "/api/auth/signout";
};
export const getApiAuthSignout_TYPE = function () {
  return "get";
};
export const getApiAuthSignoutURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/signout";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: postApiAuthSignout
 * url: postApiAuthSignoutURL
 * method: postApiAuthSignout_TYPE
 * raw_url: postApiAuthSignout_RAW_URL
 */
export const postApiAuthSignout = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/signout";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("post", domain + path, body, queryParameters, form, config);
};
export const postApiAuthSignout_RAW_URL = function () {
  return "/api/auth/signout";
};
export const postApiAuthSignout_TYPE = function () {
  return "post";
};
export const postApiAuthSignoutURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/signout";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: postApiAuthRegeneratePasswordSms
 * url: postApiAuthRegeneratePasswordSmsURL
 * method: postApiAuthRegeneratePasswordSms_TYPE
 * raw_url: postApiAuthRegeneratePasswordSms_RAW_URL
 * @param recaptcha -
 * @param email -
 * @param tc -
 * @param taxnumber -
 */
export const postApiAuthRegeneratePasswordSms = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/RegeneratePassword/sms";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters["recaptcha"] !== undefined) {
    queryParameters["recaptcha"] = parameters["recaptcha"];
  }
  if (parameters["email"] !== undefined) {
    form["Email"] = parameters["email"];
  }
  if (parameters["tc"] !== undefined) {
    form["Tc"] = parameters["tc"];
  }
  if (parameters["taxnumber"] !== undefined) {
    form["Taxnumber"] = parameters["taxnumber"];
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("post", domain + path, body, queryParameters, form, config);
};
export const postApiAuthRegeneratePasswordSms_RAW_URL = function () {
  return "/api/auth/RegeneratePassword/sms";
};
export const postApiAuthRegeneratePasswordSms_TYPE = function () {
  return "post";
};
export const postApiAuthRegeneratePasswordSmsURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/RegeneratePassword/sms";
  if (parameters["recaptcha"] !== undefined) {
    queryParameters["recaptcha"] = parameters["recaptcha"];
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: postApiAuthRegeneratePasswordSmsSet
 * url: postApiAuthRegeneratePasswordSmsSetURL
 * method: postApiAuthRegeneratePasswordSmsSet_TYPE
 * raw_url: postApiAuthRegeneratePasswordSmsSet_RAW_URL
 * @param recaptcha -
 * @param password -
 * @param code -
 * @param email -
 * @param tc -
 * @param taxnumber -
 */
export const postApiAuthRegeneratePasswordSmsSet = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/RegeneratePassword/sms/set";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters["recaptcha"] !== undefined) {
    queryParameters["recaptcha"] = parameters["recaptcha"];
  }
  if (parameters["password"] !== undefined) {
    form["Password"] = parameters["password"];
  }
  if (parameters["password"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: password"));
  }
  if (parameters["code"] !== undefined) {
    form["Code"] = parameters["code"];
  }
  if (parameters["code"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: code"));
  }
  if (parameters["email"] !== undefined) {
    form["Email"] = parameters["email"];
  }
  if (parameters["tc"] !== undefined) {
    form["Tc"] = parameters["tc"];
  }
  if (parameters["taxnumber"] !== undefined) {
    form["Taxnumber"] = parameters["taxnumber"];
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("post", domain + path, body, queryParameters, form, config);
};
export const postApiAuthRegeneratePasswordSmsSet_RAW_URL = function () {
  return "/api/auth/RegeneratePassword/sms/set";
};
export const postApiAuthRegeneratePasswordSmsSet_TYPE = function () {
  return "post";
};
export const postApiAuthRegeneratePasswordSmsSetURL = function (
  parameters = {}
) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/RegeneratePassword/sms/set";
  if (parameters["recaptcha"] !== undefined) {
    queryParameters["recaptcha"] = parameters["recaptcha"];
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: postApiAuthRegisterSingular
 * url: postApiAuthRegisterSingularURL
 * method: postApiAuthRegisterSingular_TYPE
 * raw_url: postApiAuthRegisterSingular_RAW_URL
 * @param recaptcha -
 * @param firstname -
 * @param lastname -
 * @param birthyear -
 * @param email -
 * @param phone -
 * @param tc -
 * @param password -
 * @param singulartypeid -
 */
export const postApiAuthRegisterSingular = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/Register/singular";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters["recaptcha"] !== undefined) {
    queryParameters["recaptcha"] = parameters["recaptcha"];
  }
  if (parameters["firstname"] !== undefined) {
    form["Firstname"] = parameters["firstname"];
  }
  if (parameters["firstname"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: firstname"));
  }
  if (parameters["lastname"] !== undefined) {
    form["Lastname"] = parameters["lastname"];
  }
  if (parameters["lastname"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: lastname"));
  }
  if (parameters["birthyear"] !== undefined) {
    form["Birthyear"] = parameters["birthyear"];
  }
  if (parameters["birthyear"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: birthyear"));
  }
  if (parameters["email"] !== undefined) {
    form["Email"] = parameters["email"];
  }
  if (parameters["email"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: email"));
  }
  if (parameters["phone"] !== undefined) {
    form["Phone"] = parameters["phone"];
  }
  if (parameters["phone"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: phone"));
  }
  if (parameters["tc"] !== undefined) {
    form["Tc"] = parameters["tc"];
  }
  if (parameters["tc"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: tc"));
  }
  if (parameters["password"] !== undefined) {
    form["Password"] = parameters["password"];
  }
  if (parameters["password"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: password"));
  }
  if (parameters["singulartypeid"] !== undefined) {
    form["Singulartypeid"] = parameters["singulartypeid"];
  }
  if (parameters["singulartypeid"] === undefined) {
    return Promise.reject(
      new Error("Missing required  parameter: singulartypeid")
    );
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("post", domain + path, body, queryParameters, form, config);
};
export const postApiAuthRegisterSingular_RAW_URL = function () {
  return "/api/auth/Register/singular";
};
export const postApiAuthRegisterSingular_TYPE = function () {
  return "post";
};
export const postApiAuthRegisterSingularURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/Register/singular";
  if (parameters["recaptcha"] !== undefined) {
    queryParameters["recaptcha"] = parameters["recaptcha"];
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: postApiAuthRegisterCorporate
 * url: postApiAuthRegisterCorporateURL
 * method: postApiAuthRegisterCorporate_TYPE
 * raw_url: postApiAuthRegisterCorporate_RAW_URL
 * @param recaptcha -
 * @param name -
 * @param taxnumber -
 * @param taxadministrationId -
 * @param address -
 * @param city -
 * @param phone -
 * @param fax -
 * @param web -
 * @param email -
 * @param corporatetypeId -
 * @param password -
 */
export const postApiAuthRegisterCorporate = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/Register/corporate";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters["recaptcha"] !== undefined) {
    queryParameters["recaptcha"] = parameters["recaptcha"];
  }
  if (parameters["name"] !== undefined) {
    form["Name"] = parameters["name"];
  }
  if (parameters["name"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: name"));
  }
  if (parameters["taxnumber"] !== undefined) {
    form["Taxnumber"] = parameters["taxnumber"];
  }
  if (parameters["taxnumber"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: taxnumber"));
  }
  if (parameters["taxadministrationId"] !== undefined) {
    form["TaxadministrationId"] = parameters["taxadministrationId"];
  }
  if (parameters["taxadministrationId"] === undefined) {
    return Promise.reject(
      new Error("Missing required  parameter: taxadministrationId")
    );
  }
  if (parameters["address"] !== undefined) {
    form["Address"] = parameters["address"];
  }
  if (parameters["address"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: address"));
  }
  if (parameters["city"] !== undefined) {
    form["City"] = parameters["city"];
  }
  if (parameters["phone"] !== undefined) {
    form["Phone"] = parameters["phone"];
  }
  if (parameters["phone"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: phone"));
  }
  if (parameters["fax"] !== undefined) {
    form["Fax"] = parameters["fax"];
  }
  if (parameters["web"] !== undefined) {
    form["Web"] = parameters["web"];
  }
  if (parameters["email"] !== undefined) {
    form["Email"] = parameters["email"];
  }
  if (parameters["email"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: email"));
  }
  if (parameters["corporatetypeId"] !== undefined) {
    form["CorporatetypeId"] = parameters["corporatetypeId"];
  }
  if (parameters["corporatetypeId"] === undefined) {
    return Promise.reject(
      new Error("Missing required  parameter: corporatetypeId")
    );
  }
  if (parameters["password"] !== undefined) {
    form["Password"] = parameters["password"];
  }
  if (parameters["password"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: password"));
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("post", domain + path, body, queryParameters, form, config);
};
export const postApiAuthRegisterCorporate_RAW_URL = function () {
  return "/api/auth/Register/corporate";
};
export const postApiAuthRegisterCorporate_TYPE = function () {
  return "post";
};
export const postApiAuthRegisterCorporateURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/Register/corporate";
  if (parameters["recaptcha"] !== undefined) {
    queryParameters["recaptcha"] = parameters["recaptcha"];
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
* Email veya telefon numarası bilgisi kayıt sorgulaması yapılır. Badrequest ise kullanıcı bulunamadğı zaman verilen cevaplar arasındadır.
Eğer kullanıcı bulunur ve pin numarası zaten bulunmakta ise
* request: postApiAuthRegisterSmsresend
* url: postApiAuthRegisterSmsresendURL
* method: postApiAuthRegisterSmsresend_TYPE
* raw_url: postApiAuthRegisterSmsresend_RAW_URL
     * @param email - 
     * @param phone - 
*/
export const postApiAuthRegisterSmsresend = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/Register/smsresend";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters["email"] !== undefined) {
    form["email"] = parameters["email"];
  }
  if (parameters["phone"] !== undefined) {
    form["phone"] = parameters["phone"];
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("post", domain + path, body, queryParameters, form, config);
};
export const postApiAuthRegisterSmsresend_RAW_URL = function () {
  return "/api/auth/Register/smsresend";
};
export const postApiAuthRegisterSmsresend_TYPE = function () {
  return "post";
};
export const postApiAuthRegisterSmsresendURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/Register/smsresend";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
/**
 *
 * request: postApiAuthRegisterSmsconfirm
 * url: postApiAuthRegisterSmsconfirmURL
 * method: postApiAuthRegisterSmsconfirm_TYPE
 * raw_url: postApiAuthRegisterSmsconfirm_RAW_URL
 * @param userid -
 * @param code -
 */
export const postApiAuthRegisterSmsconfirm = function (parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  const config = parameters.$config;
  let path = "/api/auth/Register/smsconfirm";
  let body;
  let queryParameters = {};
  let form = {};
  if (parameters["userid"] !== undefined) {
    form["userid"] = parameters["userid"];
  }
  if (parameters["userid"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: userid"));
  }
  if (parameters["code"] !== undefined) {
    form["code"] = parameters["code"];
  }
  if (parameters["code"] === undefined) {
    return Promise.reject(new Error("Missing required  parameter: code"));
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  return request("post", domain + path, body, queryParameters, form, config);
};
export const postApiAuthRegisterSmsconfirm_RAW_URL = function () {
  return "/api/auth/Register/smsconfirm";
};
export const postApiAuthRegisterSmsconfirm_TYPE = function () {
  return "post";
};
export const postApiAuthRegisterSmsconfirmURL = function (parameters = {}) {
  let queryParameters = {};
  const domain = parameters.$domain ? parameters.$domain : getDomain();
  let path = "/api/auth/Register/smsconfirm";
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName];
    });
  }
  let keys = Object.keys(queryParameters);
  return (
    domain +
    path +
    (keys.length > 0
      ? "?" +
        keys
          .map((key) => key + "=" + encodeURIComponent(queryParameters[key]))
          .join("&")
      : "")
  );
};
